import BillingBmCodelkupIndex from "@/components/billing/bm_codelkup/BillingBmCodelkupIndex.vue";

let routesBillingBmCodelkupIndex= [
    {
        path: '',
        meta: {
          title: "Billing BM Code",
        },
        name: "BillingBmCodelkupIndex",
        component: BillingBmCodelkupIndex
    },
    
]

export default routesBillingBmCodelkupIndex
  